
import { defineComponent, ref } from '@nuxtjs/composition-api'
import { isOnlineOrderAvailable } from '~/assets/ts/NoOnlineOrder'
import AppointmentBubble from '~/components/AppointmentBubble.vue'
import Chat from '~/components/Chat.vue'
import LanguageCheck from '~/components/LanguageCheck.vue'
import { CookieConsent } from '~/assets/ts/CookieConsent'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  components: { LanguageCheck, Chat, AppointmentBubble },
  setup() {
    const curYear = ref(new Date().getFullYear())

    const countryTax = ref('')
    const countryCode: any = getCountryCode(true).toString()

    const pinterestPage = process.env.pinterestPage
      ? process.env.pinterestPage[countryCode]
      : ('https://www.pinterest.de/acredotrauringe/' as any)

    const instagramPage = process.env.instagram
      ? process.env.instagram[countryCode]
      : ('https://www.instagram.com/acredo_official/' as any)

    const youtubePage = process.env.youtube
      ? process.env.youtube[countryCode]
      : ('https://www.youtube.com/c/acredo_official' as any)

    const facebookPage = process.env.facebookPage
      ? process.env.facebookPage[countryCode]
      : ('https://www.facebook.com/acredo/' as any)

    const twitterPage = process.env.twitter
      ? process.env.twitter[countryCode]
      : ('https://twitter.com/Acredo_Ringe' as any)

    if (process.env.tax)
      if (typeof process.env.tax[countryCode] !== 'undefined') {
        countryTax.value = process.env.tax[countryCode]
      }

    /**
     * Cookie consent
     */

    const CookieConsentObj = new CookieConsent(getCountryCode(), false)
    const isCookieConsentNecessary = CookieConsentObj.isConsentNecessary()

    return {
      curYear,
      countryTax,
      countryCode,
      isOnlineOrderAvailable,
      pinterestPage,
      instagramPage,
      youtubePage,
      facebookPage,
      twitterPage,
      isCookieConsentNecessary,
    }
  },
})
